<template>
  <div>
    <div v-show="isCompress">
    <v-tooltip  bottom>
      <template v-slot:activator="{ on }">
        <div v-on="on" class="red--text">
          {{ item.name }}
          {{$t('display/advert:overview.compressing')}}
        </div>
      </template>
      <span>{{$t('display/advert:overview.compressing-text')}}</span>
    </v-tooltip>
    </div>
    <div v-show="!isCompress" >
      {{ item.name }}
    </div>
  </div>
</template>

<script>

export default {
  name: "NameCompressionField",
  props: {
    item: {}
  },
  computed: {
    isCompress() {
      return this.item && this.item.media && this.item.media.active === 'DEACTIVATED';
    }
  }
}
</script>
